function debounce(fn, wait) {
	let t;
	return (...args) => {
	  clearTimeout(t);
	  t = setTimeout(() => fn.apply(this, args), wait);
	};
  }
  
  function fetchConfig(type = 'json') {
	return {
	  method: 'POST',
	  headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
	};
  }
  let subscribers = {}
  const ON_CHANGE_DEBOUNCE_TIMER = 300;
  
  const PUB_SUB_EVENTS = {
	cartUpdate: 'cart-update',
	quantityUpdate: 'quantity-update',
	variantChange: 'variant-change'
  };
  function publish(eventName, data) {
	if (subscribers[eventName]) {
	  subscribers[eventName].forEach((callback) => {
		callback(data)
	  })
	}
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
	window.Shopify = {};
  }
  
  Shopify.bind = function (fn, scope) {
	return function () {
	  return fn.apply(scope, arguments);
	}
  };
  
  Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
	  var option = selector.options[i];
	  if (value == option.value || value == option.innerHTML) {
		selector.selectedIndex = i;
		return i;
	  }
	}
  };
  
  Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
  };
  
  Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};
  
	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);
  
	for (var key in params) {
	  var hiddenField = document.createElement("input");
	  hiddenField.setAttribute("type", "hidden");
	  hiddenField.setAttribute("name", key);
	  hiddenField.setAttribute("value", params[key]);
	  form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
  };
  
  // todo - this should be done with liquid, literally just displays the from word or not.
//   function checkVariantRadios() {
// 	const inputElements = document.querySelectorAll('.product-form__input--content input');
// 	const variantPrices = Array.from(document.querySelectorAll('.variant-price'));
  
// 	// Convert the variant prices to numbers for comparison
// 	const variantPriceValues = variantPrices.map(price => Number(price.getAttribute('data-variant-price')));
  
// 	// Check if any of the prices are different from the first price
// 	const isPricesDifferent = variantPriceValues.some((price, i, prices) =>
// 	  i > 0 && price !== prices[0]
// 	);
  
// 	const fromWordElements = document.querySelectorAll('.from-word');
  
// 	fromWordElements.forEach(fromWord => {
// 	  if ((inputElements.length > 1) && isPricesDifferent) {
// 		fromWord.style.display = ''; // Show the 'from-word' element
// 	  } else {
// 		fromWord.style.display = 'none'; // Hide the 'from-word' element
// 	  }
// 	});
//   }
//   window.addEventListener('DOMContentLoaded', checkVariantRadios);
  
  //todo - again, do we need to do this with js?
  // window.onload = function () {
  //   const colorVariant = document.querySelector('.colorVariant');
  //   if (colorVariant) {
  //     const firstRadio = colorVariant.querySelector('input[type="radio"]');
  //     if (firstRadio) {
  //       firstRadio.checked = true;
  //     }
  //   }
  // };
  
  class VariantSelects extends HTMLElement {
	constructor() {
	  super();
	  // this.addEventListener('change', this.onVariantChange);
  
	}
	onVariantChange() {
	  this.updateOptions();
	  this.updateMasterId();
	  this.removeErrorMessage();
	  this.updateVariantStatuses();
  
	  if (!this.currentVariant) {
		this.toggleAddButton(true, 'Add to Cart', true); // Disabled, say "Select a Size"
		this.setUnavailable();
	  } else if (!this.currentVariant.available) {
		this.toggleAddButton(true, 'Sold Out', true); // Disabled, say "Sold Out"

		console.log('sold out, unhide notify when back in stock');
	  } else {
		// Enable the button and set text to "Add to Cart"
		this.toggleAddButton(false, '', true);
		this.updateURL();
		this.updateVariantInput();
		//this.renderProductInfo();
		this.updateInventory();

		console.log('available - hide notify when back in stock');
	  }
	  // setTimeout(() => {
	  // this.updatePickupAvailability();
	  // }, 400);
	}
  
	connectedCallback() {
	  this.addEventListener('change', this.onVariantChange);
  
	  if (this.hasVariants()) {
		//this.toggleAddButton(true, 'Add to Cart', true);
	  } else {
		//this.toggleAddButton(false, 'Add to Cart', true);
	  }
	}
  
	hasVariants() {
	  const variantElements = this.querySelectorAll('#varSelect input[type="radio"]');
	  return variantElements.length > 1;
	}
  
	updateInventory() {
	  const inventoryElement = document.getElementById('inventory-quantity');
	  if (inventoryElement && this.currentVariant) {
		if (this.currentVariant.inventory_quantity < 6 && this.currentVariant.inventory_quantity > 0) {
		  inventoryElement.innerHTML = `Only ${this.currentVariant.inventory_quantity} left`;
		} else {
		  inventoryElement.innerHTML = ''; // Clear the text if quantity is 6 or more // or is 0 or less
		}
	  }
	}
	updateOptions() {
	  this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}
  
	updateMasterId() {
	  this.currentVariant = this.getVariantData().find((variant) => {
		return !variant.options.map((option, index) => {
		  return this.options[index] === option;
		}).includes(false);
	  });
	}
  
	updateURL() {
	  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
	  window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	// controls which variant is currently selected
	// updateVariantInput() {
	//   const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
	//   productForms.forEach((productForm) => {
	// 	const input = productForm.querySelector('input[name="id"]');
	// 	input.value = this.currentVariant.id;
	// 	input.dispatchEvent(new Event('change', { bubbles: true }));
  
	//   });
	// }
  
	//----- new variant update using the select element with variant data
	updateVariantInput() {
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
		productForms.forEach((productForm) => {
			const select = productForm.querySelector('select[name="id"]');
			const options = select.querySelectorAll('option');
			options.forEach((option) => {
				if (option.value == this.currentVariant.id) {
					option.selected = true;

					this.updatePrices(option.dataset.price, option.dataset.compareAtPrice)
					
					//update klarna price on variant change
					document.querySelector('klarna-placement').dataset.purchaseAmount = option.dataset.unformattedPrice;
				}
			})
			select.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	updatePrices(price, compare) {
		const pdpPrice = document.querySelector('#pdp-price');
		const pdpCompare = document.querySelector('#pdp-compare-price');
		const pdpFrom = document.querySelector('#pdp-from')
		console.log(compare);

		pdpPrice.innerText = price;
		pdpFrom.classList.add('hidden');
		if (compare != '') { // this is a string, not a number, so we can use shopify's currency conversion values instead of needing to format it here
			pdpCompare.innerText = compare;
			pdpCompare.classList.remove('hidden');
			pdpPrice.classList.add('text-red');
		} else {
			pdpCompare.innerText = compare;
			pdpCompare.classList.add('hidden');
			pdpPrice.classList.remove('text-red');
		}
	}

	//todo - only works when the size selectors are used and size is the first option. Crazy.
	updateVariantStatuses() {
	  const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
	  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
	  inputWrappers.forEach((option, index) => {
		if (index === 0) return;
		const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
		const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
		const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
		this.setInputAvailability(optionInputs, availableOptionInputsValue)
	  });
	}
  
	setInputAvailability(listOfOptions, listOfAvailableOptions) {
	  listOfOptions.forEach(input => {
		if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
		  input.innerText = input.getAttribute('value');
		} else {
		  input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
		}
	  });
	}
  
  //   updatePickupAvailability() {
  //     const pickupBox = document.getElementById('pickup-box');
  //     // Fetch the data for the currently selected variant
  //     // console.log(this.currentVariant.id);
  //     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=json`)
  //       .then(response => response.json())
  //       .then(data => {
  //         setTimeout(() => {
  //           // Determine the availability status
  //           const isAvailable = data.available === 'true';  // Be careful, this is string comparison
  //           // console.log(isAvailable)
  //           // Handle the display of availability status in the UI
  //           if (isAvailable) {
  //             pickupBox.style.display = 'block';
  //           } else {
  //             pickupBox.style.display = 'none';
  //           }
  //         }, 400);
  //       })
  //       .catch(error => console.error(`Error fetching availability: ${error}`));
  //   }
  
	removeErrorMessage() {
	  const section = this.closest('section');
	  if (!section) return;
  
	  const productForm = section.querySelector('product-form');
	  if (productForm) productForm.handleErrorMessage();
	}
  
	//fires only when variant manually selected - todo, should NOT require a fetch request
	// renderProductInfo() {
	//   const requestedVariantId = this.currentVariant.id;
	//   const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
	//   fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
	// 	.then((response) => response.text())
	// 	.then((responseText) => {
	// 	  // prevent unnecessary ui changes from abandoned selections
	// 	  if (this.currentVariant.id !== requestedVariantId) return;
  
	// 	  const html = new DOMParser().parseFromString(responseText, 'text/html')
	// 	  const destination = document.getElementById(`price-${this.dataset.section}`);
	// 	  const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
	// 	  const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
	// 	  const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
	// 	  if (source && destination) destination.innerHTML = source.innerHTML;
	// 	  if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
	// 	  document.querySelector('.price-from').classList.add('hidden')
	// 	  const price = document.getElementById(`price-${this.dataset.section}`);
	// 	  price.classList.remove('hidden')
	// 	  if (price) price.classList.remove('hidden');
  
	// 	  if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
  
	// 	  const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
	// 	  this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
  
	// 	  // publish(PUB_SUB_EVENTS.variantChange, {
	// 	  //   data: {
	// 	  //     sectionId,
	// 	  //     html,
	// 	  //     variant: this.currentVariant
	// 	  //   }
	// 	  // });
	// 	});
	// }
  
	//fires on page load
	toggleAddButton(disable = true, text = '', modifyClass = true) {
		console.log('toggleAddButton()');
	  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
	  if (!productForm) return;
	  const addButton = productForm.querySelector('[name="add"]');
	  const addButtonText = productForm.querySelector('[name="add"] > span');
	  const scroller = productForm.querySelector('.product-sticky-addcart-scroller');
	  const bisButton = productForm.querySelector('#BIS_trigger');
	  const dynamicATC = productForm.querySelector('.shopify-payment-button');
	  let pickupBox = document.querySelector('#pickup-container');
	  
	  if (!addButton) return;
  
	  // Remove existing click event to prevent multiple bindings
	  // scroller.removeEventListener('click', this.scrollToTop);
  
	  if (disable) {
		// scroller.classList.add('active');
		// scroller.addEventListener('click', this.scrollToTop);
		if (bisButton) {
			addButton.classList.add('hidden');
			bisButton.classList.remove('hidden');
			if (dynamicATC) dynamicATC.classList.add('hidden');
		}

		if (text) {
		  addButtonText.textContent = text; // Sold Out
		}

		if (pickupBox) { 
			pickupBox.classList.add('hidden'); 
		}
	  } else {
		addButton.removeAttribute('disabled');
		if (bisButton) {
			addButton.classList.remove('hidden');
			bisButton.classList.add('hidden');
			if (dynamicATC) dynamicATC.classList.remove('hidden');
		}

		// scroller.classList.remove('active');
		addButtonText.textContent = window.variantStrings.addToCart; // Add to Cart

		if (pickupBox) { 
			pickupBox.classList.remove('hidden');
		}
	  }
  
	  if (!modifyClass) return;
	}
  
	scrollToTop() {
	  window.scrollTo({ top: 0, behavior: 'smooth' });
	}
  
	setUnavailable() {
		console.log('setUnavailable()');
	  const button = document.getElementById(`product-form-${this.dataset.section}`);
	  const addButton = button.querySelector('[name="add"]');
	  const addButtonText = button.querySelector('[name="add"] > span');
	  const price = document.getElementById(`price-${this.dataset.section}`);
	  const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
	  const sku = document.getElementById(`Sku-${this.dataset.section}`);
  
	  if (!addButton) return;
	  addButtonText.textContent = window.variantStrings.unavailable;
	  if (price) price.classList.add('hidden');
	  if (inventory) inventory.classList.add('hidden');
	  if (sku) sku.classList.add('hidden');
	}
  
	// requires the json info from main-product
	getVariantData() {
	  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
	  return this.variantData;
	}
  
	// duplicate?
	scrollToTop() {
	  window.scrollTo({ top: 0, behavior: 'smooth' });
	}
}
customElements.define('variant-selects', VariantSelects);
  
class VariantRadios extends VariantSelects {
	constructor() {
	  super();
	}
  
	setInputAvailability(listOfOptions, listOfAvailableOptions) {
	  listOfOptions.forEach(input => {
		if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
		  input.classList.remove('disabled');
		} else {
		  input.classList.add('disabled');
		}
	  });
	}
  
	updateOptions() {
	  const fieldsets = Array.from(this.querySelectorAll('.product-form__input'));
	  this.options = fieldsets.map((fieldset) => {
		return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
	  });
	}
}
customElements.define('variant-radios', VariantRadios);


// document.addEventListener("DOMContentLoaded", function () {
//     const productForm = document.querySelector('product-form');
//     const stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');

//     function updateStickyAddToCartButton() {
//         if (!productForm || !stickyAddToCartButton) return;

//         const rect = productForm.getBoundingClientRect();
//         const isVisible = !(rect.bottom < 0 || rect.top > window.innerHeight);

//         if (!isVisible) {
//             stickyAddToCartButton.style.display = 'block';
//             stickyAddToCartButton.innerHTML = productForm.innerHTML;
//         } else {
//             stickyAddToCartButton.style.display = 'none';
//         }
//     }

//     updateStickyAddToCartButton();
//     window.addEventListener('scroll', updateStickyAddToCartButton);

//     const addToCartButton = productForm.querySelector('button');
//     if (!addToCartButton || !stickyAddToCartButton) return;

//     let observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//             if (mutation.type == "attributes") {
//                 stickyAddToCartButton.disabled = addToCartButton.disabled;
//                 stickyAddToCartButton.innerText = addToCartButton.innerText;
//             }
//         });
//     });

//     observer.observe(addToCartButton, {
//         attributes: true
//     });
// });
  




// ------------- moved here from product.js ------------
// function productSwiper() {
//     // var galleryThumbs = new Swiper(".gallery-thumbs", {
//     //     direction: "vertical",
//     //     spaceBetween: 10,
//     //     slidesPerView: 5,
//     //     watchSlidesVisibility: true,
//     //     freeMode: true,
//     //     navigation: { // задаем кнопки навигации
//     //         nextEl: '.thumb_slider__next', // кнопка Next
//     //         prevEl: '.thumb_slider__prev' // кнопка Prev
//     //     },

//     // });
//     var galleryTop = new Swiper(".gallery-top", {
//         spaceBetween: 10,
//         navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//         thumbs: {
//             swiper: galleryThumbs
//         },
//         a11y: {
//             prevSlideMessage: "Previous slide",
//             nextSlideMessage: "Next slide",
//         },
//         keyboard: {
//             enabled: true,
//         }
//     });

// }

function estimatedDelivery() {
    function estimateDelivery(minDays, maxDays) {
        var minDate = new Date();
        minDate = addBusinessDays(minDate, minDays);

        var maxDate = new Date();
        maxDate = addBusinessDays(maxDate, maxDays);

        var options = { month: 'short', day: 'numeric' };

        return minDate.toLocaleDateString(undefined, options) + ' - ' + maxDate.toLocaleDateString(undefined, options);
    }

    function addBusinessDays(date, days) {
        var count = 0;
        var holidays = [
			'2024-12-24', // Christmas Eve
            '2024-12-25', // Christmas
            '2024-12-26', // Boxing Day
            // add more dates as 'YYYY-MM-DD'
        ];

        while (count < days) {
            date.setDate(date.getDate() + 1);
            var dateString = date.toISOString().slice(0, 10); // format date as 'YYYY-MM-DD'
            if (date.getDay() !== 0 && date.getDay() !== 6 && !holidays.includes(dateString)) {  // if it's not Sunday (0), Saturday (6), or a holiday
                count++;
            }
        }
        return date;
    }

    const elementE = document.getElementById("deliveryDates");
    
    if (elementE) {
        elementE.innerText = estimateDelivery(3, 5);
    }

    // console.log(estimateDelivery(5, 12));
}

// product page image swiper
function scrollGallery() {
	// old vertical thumbnails, leave in case we want to re-enable them
    // var galleryThumbs = new Swiper(".gallery-thumbs-scroll", {
    //     direction: "vertical",
    //     spaceBetween: 10,
    //     slidesPerView: 5,
    //     watchSlidesVisibility: true,
    //     freeMode: true,
    //     //navigation: { 
    //         //nextEl: '.swiper-button-next', 
    //         //prevEl: '.swiper-button-prev' 
    //     //},
    //     on: {
    //         init: function () {
    //             var slider = document.querySelector('.gallery-thumbs-scroll');
    //             slider.classList.remove('opacity-0');
    //             slider.classList.add('opacity-100');
    //         }
    //     }
    // });
    // const thumbnails = document.querySelectorAll('.slide-image-thumb');
    // const images = document.querySelectorAll('.scroll-image .slide-image');

    // // Set active class on the first thumbnail on page load
    // thumbnails[0].parentNode.classList.add('thumb-active');

    // thumbnails.forEach((thumbnail, index) => {
    //     thumbnail.addEventListener('click', (event) => {
    //         event.preventDefault();

    //         const targetId = event.currentTarget.getAttribute('href').slice(1);
    //         const targetElement = document.getElementById(targetId);
    //         const offset = window.innerHeight * 0.20;
    //         const position = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

    //         window.scrollTo({ top: position, behavior: 'smooth' });

    //         thumbnails.forEach((slide) => {
    //             slide.parentNode.classList.remove('thumb-active');
    //         });

    //         // Add the 'active' class to the clicked thumbnail
    //         thumbnails[index].parentNode.classList.add('thumb-active');

    //         // Move the Swiper slider to the clicked thumbnail
    //         galleryThumbs.slideTo(index);
    //     });
    // });

    // window.addEventListener('scroll', () => {
    //     // Check if scrolled to top, then activate first thumbnail
    //     if (window.scrollY === 0) {
    //         thumbnails.forEach((slide) => {
    //             slide.parentNode.classList.remove('thumb-active');
    //         });
    //         thumbnails[0].parentNode.classList.add('thumb-active');
    //         galleryThumbs.slideTo(0);
    //     } else {
    //         images.forEach((image, index) => {
    //             const rect = image.getBoundingClientRect();
    //             const isHalfVisible = rect.top + rect.height * 0.5 < 0;

    //             if (isHalfVisible) {
    //                 thumbnails.forEach((slide) => {
    //                     slide.parentNode.classList.remove('thumb-active');
    //                 });

    //                 let newIndex = -1;

    //                 // Add active class to the next thumbnail if it exists
    //                 if (thumbnails[index + 1]) {
    //                     thumbnails[index + 1].parentNode.classList.add('thumb-active');
    //                     newIndex = index + 1;
    //                 } else if (thumbnails[index]) {
    //                     // If next thumbnail doesn't exist, add active to the current one
    //                     thumbnails[index].parentNode.classList.add('thumb-active');
    //                     newIndex = index;
    //                 }

    //                 if (newIndex !== -1) {
    //                     galleryThumbs.slideTo(newIndex);
    //                 }
    //             }
    //         });
    //     }
    // });

    // breakpoint where swiper will be destroyed
    // and switches to a non-swiper layout

    const breakpoint = window.matchMedia('(min-width:1024px)');

    // keep track of swiper instances to destroy later
    let mySwiper;

    const breakpointChecker = function () {
        // if larger viewport and non-swiper layout needed
        if (breakpoint.matches === true) {
            // clean up old instances and inline styles when available
            if (mySwiper !== undefined) mySwiper.destroy(true, true);

            // or/and do nothing
            return;

            // else if a small viewport and swiper layout needed
        } else if (breakpoint.matches === false) {
            // fire small viewport version of swiper
            return enableSwiper();
        }
    };

    const enableSwiper = function () {
        mySwiper = new Swiper('[data-product-mobile-slider]', {
            keyboardControl: true,
            grabCursor: true,
			loop: false,
            pagination: {
                el: ".swiper-pagination-mob",
                clickable: true
            },
			preloadImages: false,
            lazy: {
				checkInView: true,
				loadOnTransitionStart: true
			},
            draggable: true,
            slidesPerView: 1,
            keyboardControl: true,
            navigation: false

        });
    };

    // keep an eye on viewport size changes
    breakpoint.addEventListener('change', breakpointChecker);

    // kickstart
    breakpointChecker();

}

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
        var targetContainer = document.querySelector('.content-sizes');

        // If the target container doesn't exist, exit early
        if (!targetContainer) return;

        var variantPrices = [...targetContainer.querySelectorAll('.variant-price[data-variant-price]')];
        var firstPrice = String(variantPrices[0].getAttribute('data-variant-price'));

        var allSame = true; // default to true

        variantPrices.forEach(function (priceElement) {
            var currentPrice = String(priceElement.getAttribute('data-variant-price'));
            if (currentPrice !== firstPrice) {
                allSame = false;
            }
        });

        if (allSame) {
            variantPrices.forEach(function (priceElement) {
                priceElement.classList.add('hidden');
            });
        }
    }
});

// appends the sticky add to cart bar to bottom of page on mobile beyond certain scroll depth
function stickyCart() {
    let reachedEnd = false;
    let timeoutId = null;

    function isAboveOrTouchingTopViewport(element, offset = 50) {
        const rect = element.getBoundingClientRect();
        return rect.bottom <= offset;
    }

    function isPageEnd(offset = 50) {
        return window.innerHeight + window.scrollY >= document.body.offsetHeight - offset;
    }

    function toggleClasses() {
		if (window.innerWidth <= 768) {
			if (isPageEnd()) {
				mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
			} else if (isAboveOrTouchingTopViewport(estimatedDelivery, 50)) {
				mainProductForm.classList.remove('start-sticky-cart');
				mainProductForm.classList.add('sticky-cart');
			} else if (isAboveOrTouchingTopViewport(estimatedDelivery, 49)) {
				mainProductForm.classList.add('start-sticky-cart');
				mainProductForm.classList.remove('sticky-cart');
			} else {
				mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
			}
		} else {
			mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
		}

        // if (timeoutId) {
        //     clearTimeout(timeoutId);
        // }

        // timeoutId = setTimeout(() => {
        //     if (window.innerWidth <= 768) {
        //         if (isPageEnd()) {
        //             mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
        //         } else if (isAboveOrTouchingTopViewport(estimatedDelivery, 50)) {
        //             mainProductForm.classList.remove('start-sticky-cart');
        //             mainProductForm.classList.add('sticky-cart');
        //         } else if (isAboveOrTouchingTopViewport(estimatedDelivery, 49)) {
        //             mainProductForm.classList.add('start-sticky-cart');
        //             mainProductForm.classList.remove('sticky-cart');
        //         } else {
        //             mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
        //         }
        //     } else {
        //         mainProductForm.classList.remove('sticky-cart', 'start-sticky-cart');
        //     }
        // }, 20);
    }

    const mainProductForm = document.querySelector('#mainProductForm');
    const estimatedDelivery = document.querySelector('[data-active-sticky-cart]');

	if (mainProductForm != null) {
		window.addEventListener('scroll', toggleClasses);
		window.addEventListener('resize', toggleClasses);
	
		toggleClasses();
	}
	
}

// countdown timer on express delivery cut off
function expressDelivery() {
    // Function to get the next weekday, considering an additional offset
    function getNextWeekday(date, offset = 1) {
        let nextDate = new Date(date.getTime());
        for (let i = 0; i < offset; i++) {
            do {
                nextDate.setDate(nextDate.getDate() + 1);
            } while (nextDate.getDay() === 0 || nextDate.getDay() === 6); // Skip weekends
        }
        return nextDate;
    }
    
    // Function to format the date in "Thu 31 Aug" format
    function formatDate(date) {
        const options = { weekday: 'short', day: 'numeric', month: 'short' };
        return date.toLocaleDateString('en-US', options);
    }

    // This function will update the timer
    function updateTimer() {
        const now = new Date();
        const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, etc.

        const currentMonth = now.getMonth();//returns num
        const dateOfMonth = now.getDate();//returns num

        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        const currentSecond = now.getSeconds();

        const startHour = 0; // 12 AM (midnight)
        const endHour = 12; // 12 PM (lunchtime)

        const expressDeliveryCounter = document.querySelector('.expressDeliveryCounter');

		if (expressDeliveryCounter == undefined) return;

        //Current year, Dec, 21st, 10am, 0mins, 0secs
        const xmasStart = new Date(new Date().getFullYear(), 11, 18, 0, 0, 0);
        const xmasCutoff = new Date(new Date().getFullYear(), 11, 22, 0, 0, 0);

        //add xmas logic with a return so the rest of the function isn't run
        if (now >= xmasStart && now < xmasCutoff) {
            const diffInSeconds = Math.floor((xmasCutoff - now) / 1000);

            const days = Math.floor(diffInSeconds / (60 * 60 * 24));
            const hours = Math.floor((diffInSeconds / (60 * 60)) % 24);
            const minutes = Math.floor((diffInSeconds % 3600) / 60);
            const seconds = diffInSeconds % 60;

            if (expressDeliveryCounter) {
                expressDeliveryCounter.innerHTML = `<span>Order within</span><span id="time" class="text-black font-bold">${days.toString().padStart(2, '0')}d ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s</span><span> for delivery before Christmas!</span>`;
                return;
            }
        }

        //function stops here if outside of next day delivery hours
        if (currentHour >= endHour || currentHour < startHour || dayOfWeek === 0 || dayOfWeek === 6) {
            // Outside of next day delivery window or it's the weekend
			const daysForward = dayOfWeek === 5 ? 3 : 2; // if Friday after 12, add an extra day
			expressDeliveryCounter.innerHTML = `<span>Order now to receive ${formatDate(getNextWeekday(now, daysForward))}</span>`;
			return;
        }

        const endTime = new Date();
        endTime.setHours(endHour);
        endTime.setMinutes(0);
        endTime.setSeconds(0);

        const diffInSeconds = Math.floor((endTime - now) / 1000);

        const hours = Math.floor(diffInSeconds / 3600);
        const minutes = Math.floor((diffInSeconds % 3600) / 60);
        const seconds = diffInSeconds % 60;

        // if after 18th Dec, until xmas delivery cutoff show xmas delivery message, hide until 27th
        if (expressDeliveryCounter) {
			// show Monday if it's Friday otherwise say tomorrow.
			if (dayOfWeek == 5) {
				expressDeliveryCounter.innerHTML = `<span>Get your order on Monday</span><p><span>if you checkout within</span><span id="time" class="ml-2 text-black font-bold">${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s</span></p>`;
			} else {
				expressDeliveryCounter.innerHTML = `<span>Get your order tomorrow</span><p><span>if you checkout within</span><span id="time" class="ml-2 text-black font-bold">${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s</span></p>`;
			}
        }
    }

    // Initial call to set the timer right away
    updateTimer();

    // Update the timer every second
    setInterval(updateTimer, 1000);
}

stickyCart();
//productSwiper()
estimatedDelivery()

// productModal();
expressDelivery();

document.addEventListener("DOMContentLoaded", function () {
    //viewMoreColors();
	scrollGallery();
});

document.addEventListener("shopify:section:load", function (event) {
    //viewMoreColors();
    stickyCart();
    // productModal();
    //productSwiper();
    estimatedDelivery();
    expressDelivery();
});


